import React from "react";

import { reduxForm, Field, Form } from "redux-form";
import { IonIcon } from "@ionic/react";
import { checkmark } from "ionicons/icons";

import { FormInput, CircleIconButton } from "../../../common";

import styled from "styled-components";

const FormContainer = styled(Form)`
  padding: 25px;
`;
const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  margin-right: 24px;
`;
const SubmitIcon = styled(IonIcon)`
  color: #ffffff;
  font-size: 2em;
`;

const EmployeeAccountForm = (props) => {
  const { handleSubmit } = props;

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Field
        name="first_name"
        component={FormInput}
        required
        maxlength={255}
        placeholder={"FIRST NAME"}
        inputStyle={"flat"}
      />
      <Field
        name="middle_name"
        component={FormInput}
        required
        maxlength={255}
        placeholder={"MIDDLE NAME"}
        inputStyle={"flat"}
      />
      <Field
        name="last_name"
        component={FormInput}
        required
        maxlength={255}
        placeholder={"LAST NAME"}
        inputStyle={"flat"}
      />
      <Field
        name="organization_title"
        component={FormInput}
        required
        maxlength={255}
        placeholder={"ORGANIZATION TITLE"}
        style={{ marginTop: "24px" }}
        inputStyle={"flat"}
      />

      <SubmitButtonContainer>
        <CircleIconButton
          type="submit"
          style={{
            width: "50px",
            height: "50px",

            display: "flex",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <SubmitIcon icon={checkmark} />
        </CircleIconButton>
      </SubmitButtonContainer>
    </FormContainer>
  );
};

export default reduxForm({
  form: "lib_account_employee_account_form",
})(EmployeeAccountForm);
